import {
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    makeStyles, mergeClasses, Image, Divider,
} from "@fluentui/react-components"
import {pinkTheme} from "../../../../styles/mission/theme";
import {useStyles} from "../../../../styles/mission/ver1";


interface AlertDialogProps {
    title: string
    description: string
    isOpen: boolean
    onClose: () => void
    src: null | string
    primaryColor: string
}

const useAlertDialogStyles = makeStyles({
    description: {
        whiteSpace: 'pre-line',
        fontSize: '14px',
        lineHeight: '20px',
        marginTop: '8px'
    },
    imageContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor:'transparent',
        padding:'7px'
    },
    divider: {
        width:'100%',
        height:'2px',
        backgroundColor: pinkTheme.outliendBtn,
    },
    root: {
        display: "flex",
        flexDirection: "column",
        rowGap: "5px",
    },
})

export default function AlertDialog({ title, description, isOpen, onClose, src, primaryColor }: AlertDialogProps) {
    const styles = useAlertDialogStyles()
    const basicStyles = useStyles()

    return (
        <Dialog open={isOpen} onOpenChange={onClose} >
            <DialogSurface >
                <DialogBody>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogContent style={{
                        display: 'flex',
                        flexDirection: 'column', gap: '20px', justifyContent: 'center', alignItems: 'center'
                    }}>
                            <div className={styles.divider}>
                                <Divider />
                            </div>
                        {src && (<div className={styles.imageContainer}>
                            <Image
                                alt="모달이미지"
                                src={src}
                                width={100}
                                height={100}
                            />
                        </div>)}
                        <div className={styles.description} style={{fontSize: 'large'}}>
                            {description}
                        </div>
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <div onClick={onClose}
                                 className={mergeClasses(basicStyles.roundedBtn, basicStyles.primaryBtn)}
                                 style={{backgroundColor: primaryColor, border: 'none'}}>
                                닫기
                            </div>
                        </div>
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    )
}